import { Map, List } from 'immutable';

import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';

class RoversRangersStore extends BaseStore {

    getInitialState () {
        return new Map({
            fares: new Map(),
            pending: new Map()
        });
    }

    getFares (search) {
        return this.state.getIn(['fares', this._getKey(search)], new List());
    }

    isPending (search) {
        return this.state.getIn(['pending', this._getKey(search)], false);
    }

    _getKey (search) {
        return JSON.stringify(search.serialize());
    }

    getActionHandlers () {
        return {
            [ActionTypes.ROVERSRANGERS_SEARCH_STARTED]: this._handleSearchStarted,
            [ActionTypes.ROVERSRANGERS_SEARCH_FINISHED]: this._handleSearchFinished
        };
    }

    _handleSearchStarted ({ search }) {
        this.setState(this.state
            .setIn(['pending', this._getKey(search)], true)
        );
    }

    _handleSearchFinished ({ search, searchResults }) {
        this.setState(this.state
            .setIn(['pending', this._getKey(search)], false)
            .setIn(['fares', this._getKey(search)], searchResults)
        );
    }
}

const storeInstance = new RoversRangersStore();

export default storeInstance;



// WEBPACK FOOTER //
// ./src/stores/RoversRangersStore.js